import { Link } from 'react-router-dom';
import { AnimatedSection } from '../components/AnimatedSection';

const PHILOSOPHY_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/unffqol3_paragon.jpg";

export const Philosophy = () => {
  return (
    <div data-testid="philosophy-page" className="bg-[#050505]">
      {/* Hero Section */}
      <section className="relative min-h-[40vh] flex items-end pb-12 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={PHILOSOPHY_IMAGE}
            alt="Calm intensity"
            className="w-full h-full object-cover opacity-50" />

          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-transparent" />
        </div>

        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 w-full">
          <AnimatedSection>
            <p className="caption-text mb-6">Philosophy</p>
            <h1 className="heading-large">Upstream</h1>
          </AnimatedSection>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-padding pt-16">
        <div className="max-w-[900px] mx-auto">
          <AnimatedSection>
            <p className="body-large mb-8">
              Most performance coaching focuses on behaviour.
            </p>
            <p className="body-text mb-4">
              Strategies. Techniques. Mental tools.
            </p>
            <p className="body-text mb-12">
              These approaches can sometimes help.<br />
              But they operate downstream.
            </p>
          </AnimatedSection>

          <AnimatedSection delay={0.2}>
            <div className="border-l border-white/20 pl-8 my-16">
              <p className="quote-text">
                Paragon works upstream.<br />
                At the source of experience itself.
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection delay={0.3}>
            <p className="body-text mb-6">The capacity for elite performance is already there.
Remove the noise, and it reveals itself.
            </p>
            <p className="body-text mb-6">From clarity of mind comes the insight, resilience, creativity and performance that is already within you..

            </p>
            <p className="body-text">
              Not as something manufactured, but as something natural.<br />
              
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Performance Without Interference */}
      <section data-testid="interference-section" className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
            <AnimatedSection>
              <p className="caption-text mb-6">The Quiet Advantage</p>
              <h2 className="heading-medium">
                Performance Without Interference
              </h2>
            </AnimatedSection>

            <AnimatedSection delay={0.2}>
              <div className="space-y-6">
                <p className="body-large">
                  Elite performers do not need more information.
                </p>
                <p className="text-white text-xl font-['Playfair_Display']">
                  They need less interference.
                </p>
                <div className="divider my-8" />
                <p className="body-text">
                  Much of the pressure people experience comes from misunderstanding how their mind works.
                </p>
                <p className="body-text">
                  When that misunderstanding falls away, something powerful happens.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* What Happens */}
      <section className="section-padding">
        <div className="max-w-[800px] mx-auto text-center">
          <AnimatedSection>
            <p className="caption-text mb-12">When Clarity Returns</p>
          </AnimatedSection>

          <div className="space-y-8">
            <AnimatedSection delay={0.1}>
              <p className="text-white font-['Playfair_Display'] text-2xl md:text-3xl">
                Thinking settles.
              </p>
            </AnimatedSection>
            <AnimatedSection delay={0.2}>
              <p className="text-white font-['Playfair_Display'] text-2xl md:text-3xl">
                Clarity returns.
              </p>
            </AnimatedSection>
            <AnimatedSection delay={0.3}>
              <p className="text-white font-['Playfair_Display'] text-2xl md:text-3xl">
                Performance emerges naturally.
              </p>
            </AnimatedSection>
          </div>

          <AnimatedSection delay={0.5}>
            <div className="divider mx-auto my-16" />
            <p className="text-white/60 italic text-lg">
              This is the quiet advantage.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[600px] mx-auto text-center">
          <AnimatedSection>
            <p className="body-text mb-8">
              Ready to discover the upstream approach?
            </p>
            <Link to="/apply" data-testid="philosophy-apply-btn" className="btn-primary">
              Begin the Conversation
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>);

};